import $ from "jquery";
$(".hero-slider").slick({
  centerMode: true,
  centerPadding: "50px",
  slidesToShow: 5,
  arrows: false,
  responsive: [
    {
      breakpoint: 1450,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});
$(".hero-caption").slick({
  arrows: true,
  asNavFor: ".hero-slider",
  fade: true,
});

$(".events-slider").slick({
  centerMode: true,
  // centerPadding: '50px',
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: true,
  // lazyLoad: ondemand,
  responsive: [
    {
      breakpoint: 1450,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      // centerPadding: '40px',
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".slider-block").slick({
  // centerMode: true,
  // centerPadding: '50px',
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  // useTransform: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$("#instagram .images").slick({
  centerMode: true,
  centerPadding: "50px",
  slidesToShow: 7,
  arrows: true,
  responsive: [
    {
      breakpoint: 1450,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 1250,
      centerPadding: "40px",
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: "40px",
        slidesToShow: 1,
      },
    },
  ],
});

// Slick slides equal height
jQuery(".events-slider, .slider-block").on("setPosition", function () {
  jQuery(this).find(".slick-slide").height("auto");
  var slickTrack = jQuery(this).find(".slick-track");
  var slickTrackHeight = jQuery(slickTrack).height();
  jQuery(this)
    .find(".slick-slide")
    .css("height", slickTrackHeight + "px");
});

// Lazy load prev Share slick img on window load
jQuery(".share-section-masonry").on("setPosition", function () {
  var src = jQuery("#share .slick-active").prev().find("img");
  var datalazy = jQuery(src).attr("data-src");
  jQuery(src).attr("src", datalazy);
});
